/**
 * The Vault's Downloads tab.
 *
 * The re-download button only appears when the record's pack still exists in the
 * fixtures. Once a backend serves packs, a download record can outlive its pack, so
 * the row has to render without one.
 *
 * SIMULATED: a "download" writes a text manifest client-side.
 */
import { Download } from 'lucide-react';
import { IconButton } from '../ui';
import { c } from '../../styles/theme';
import { Note, type VaultController } from './shared';

export interface VaultDownloadsTabProps {
  vault: VaultController;
}

export default function VaultDownloadsTab({ vault }: VaultDownloadsTabProps) {
  return (
    <div>
      <Note>Download history</Note>
      {vault.downloads.length === 0 ? (
        <Note marginBottom={0}>No packs downloaded yet.</Note>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {vault.downloads.map((d) => {
            const pack = vault.packs.find((p) => p.id === d.packId) ?? null;
            return (
              <div
                key={d.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '9px 0',
                  borderBottom: `1px solid ${c.border}`,
                }}
              >
                <div>
                  {/* `d.name`, not the prototype's `d.packName` — that field
                      was never written, so every row read "undefined". */}
                  <p style={{ fontSize: 12, fontWeight: 500, margin: 0 }}>{d.name}</p>
                  <p style={{ fontSize: 11, color: c.text3, margin: 0 }}>
                    v{d.version} · {d.date}
                  </p>
                </div>
                {pack && (
                  <IconButton
                    label={`Download ${pack.name} again`}
                    onClick={() => vault.downloadPack(pack)}
                  >
                    <Download size={14} color={c.text3} />
                  </IconButton>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
